import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 3,
  class: "content",
  role: "alert",
  "aria-busy": "true"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, " ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Copyright = _resolveComponent("Copyright")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.globalStatus)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog",
          innerHTML: _ctx.globalStatus
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createBlock(_component_Logo, {
          key: 1,
          class: "header"
        })),
    _createVNode(_component_Navigation, { class: "nav" }),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 2,
          class: "content"
        }))
      : (_openBlock(), _createElementBlock("main", _hoisted_2, _hoisted_5)),
    _createVNode(_component_Copyright, { class: "footer" })
  ], 64))
}